import React, { useEffect } from 'react'
import { withStoreProvider } from '../../Helpers/withStoreProvider'
import MediaPermissionsStore from '../PrecallTest/Components/Permissions/Stores/MediaPermissionsStore'
import Recorder from './Components/Recorder'
import UploadVid from './Components/UploadVid'
import { VideoRecordEl } from './Elements'
import VideoRecordStore from './Stores/VideoRecordStore'

function VideoRecord({ onSubmit, size_limit, maxDuration }) {
  const permissions = MediaPermissionsStore.useContainer()
  const {
    recordingState,
    submit,
    setSizeLimit,
  } = VideoRecordStore.useContainer()

  useEffect(() => {
    submit.current = (value) => onSubmit(value)
    if (size_limit) setSizeLimit(size_limit)
  }, [setSizeLimit, onSubmit, size_limit, submit])

  return (
    <VideoRecordEl>
      {permissions.includes('denied') ? (
        <h2>
          Grant camera and microphone permission in your browser settings to use
          them in the session.
        </h2>
      ) : permissions.every((p) => p === 'granted') ? (
        recordingState !== 'UPLOADING' && <Recorder maxDuration={maxDuration} />
      ) : (
        <p>Grant camera and microphone permissions to enable recording.</p>
      )}
      <UploadVid />
    </VideoRecordEl>
  )
}

export default withStoreProvider([VideoRecordStore, MediaPermissionsStore])(
  VideoRecord,
)
